import { DialogTitle, Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { web_url } from "../../constant";

const url = "http://localhost:8080/api/";
function TranslatorProfile() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);
    const navigate = useNavigate();

    // const [personDetails, setPersonalDetails] = useState(
    //     () => {
    //         const paymentDet = localStorage.getItem('payment') ? JSON.parse(localStorage.getItem('payment')) : {};
    //         return {
    //             userName: "",
    //             mobile: "",
    //             email: "",
    //             bankName: paymentDet.bankName||"",
    //             bankAccNum: paymentDet.accountNumber||"",
    //             bankBranch: paymentDet.branch||"",
    //             bankAccName: paymentDet.name||"",
    //         }
    //     }
    // );

    const [personDetails, setPersonalDetails] = useState(() => {
        const paymentData = localStorage.getItem('payment');

        let paymentDet = {};
        if (paymentData) {
            try {
                paymentDet = JSON.parse(paymentData) || {};
            } catch (error) {
                console.error("Error parsing 'payment' from localStorage:", error);
            }
        }

        return {
            userName: "",
            mobile: "",
            email: "",
            bankName: paymentDet.bankName || "",
            bankAccNum: paymentDet.accountNumber || "",
            bankBranch: paymentDet.branch || "",
            bankAccName: paymentDet.name || "",
        };
    });

    const [isLoading, setIsLoading] = useState(false);

    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
    };

    useEffect(() => {
        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();
        if (logDetails) {
            setIsLoading(true)
            // console.log(logDetails);
            const paymentDet = JSON.parse(localStorage.getItem('payment'));

            const configToken = {
                headers: {
                    'Authorization': `Bearer ${logDetails.token}`,
                },
            };

            const apiUrl = `${web_url}/api/auth/translators/${logDetails.email}`
            axios.get(apiUrl, configToken)
                .then((response) => {
                    // console.log(response.data);
                    setPersonalDetails({
                        userName: response.data.userFullName,
                        mobile: response.data.contactNumber,
                        email: response.data.userEmail,
                        bankName: paymentDet.bankName,
                        bankAccNum: paymentDet.accountNumber,
                        bankBranch: paymentDet.branch,
                        bankAccName: paymentDet.name,
                    })
                    setIsLoading(false);
                })
                .catch((err) => {

                    console.log("error occured tp", err);
                });
        }
    }, [localStorage.getItem('payment')])

    return (
        <div>
            <div className="hidden xl:flex rounded-t-lg xl:mt-[30px] 2xl:mt-[70px] bg-[#DCBE5A] xl:ml-[10px] xl:mr-[70px] xl:h-[40px] 2xl:h-[50px] items-center pl-[50px] xl:text-[16px] 2xl:text-[20px] text-[#816D2B]">{t('t147')}</div>
            <div className="xl:hidden pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]">
                <div className="flex items-center justify-start mt-[20px] lg:ml-[70px]">
                    <p className="text-[20px] ml-[10px] md:text-[23px] lg:text-[25px] xl:text-[19px] 2xl:text-[25px] font-bold">{t('t147')}</p>
                </div>
            </div>

            <div className="xl:bg-[#FFEBA9] xl:rounded-b-lg xl:ml-[10px] xl:mr-[70px] xl:min-h-[530px] 2xl:min-h-[640px]">
                {isLoading ?

                    <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                    : <>
                        <div className="flex flex-col items-center pt-[20px] xl:pt-[0px] 2xl:pt-[0px]">
                            <div className="flex flex-col pt-[20px] justify-center items-center pt-[5px]">
                                <p className="xl:pt-[30px] font-bold text-[25px] md:text-[40px] lg:text-[50px] xl:text-[30px] text-black">{personDetails.userName}</p>
                                {/* <p className="font-normal text-[19px] md:text-[27px] md:text-[35px] xl:text-[20px] text-black">{personDetails.mobile}</p> */}
                            </div>
                        </div>
                        <div className="pt-[30px]">
                            {/* <p className="pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[17px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                        {t('t148')}
                    </p> */}
                            <hr className=" border-gray-400 ml-[10px] mr-[10px] xl:mr-[10px]" />
                            <p className="font-bold mt-[20px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[18px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                {t('t148')}: <span className="font-normal">{personDetails.email}</span>
                            </p>
                            <p className="font-bold mt-[10px] pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[18px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                {t('t152_4')}: <span className="font-normal">{personDetails.mobile}</span>
                            </p>
                            <p className="font-bold mt-[10px]  pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[18px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                {t('t152_3')}: <span className="font-normal">{personDetails.bankAccName}</span>
                            </p>
                            <p className="font-bold mt-[10px]  pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[18px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                {t('t152_6')}: <span className="font-normal">{personDetails.bankName}</span>
                            </p>
                            <p className="font-bold mt-[10px]  pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[18px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                {t('t152_7')}: <span className="font-normal">{personDetails.bankBranch}</span>
                            </p>
                            <p className="font-bold mt-[10px]  pl-[30px] md:pl-[110px] lg:pl-[140px] xl:pl-[50px] pr-[30px] md:pr-[110px] lg:pr-[140px] xl:pr-[0px] text-[18px] md:text-[25px] lg:text-[30px] xl:text-[16px] 2xl:text-[20px]">
                                {t('t152_5')}: <span className="font-normal">{personDetails.bankAccNum}</span>
                            </p>
                        </div>
                    </>}
            </div>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default TranslatorProfile;